export const prescribersHeroContent = {
  title: "Find online psychiatry near you",
  blurb:
    "Connect with a responsible, licensed prescriber who will determine if medication can help you achieve your mental health goals.",
  carePersonType: "prescribers",
}
